var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyleTextColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.51769 9.61151L3.94428 0.190476C3.98594 0.0761905 4.09467 0 4.2161 0H5.88436C6.00618 0 6.11491 0.0761905 6.15618 0.190476L9.58317 9.61151C9.65182 9.8004 9.51213 10 9.31134 10H7.79547C7.67325 10 7.56452 9.92341 7.52325 9.80833L6.90261 8.08214C6.86134 7.96746 6.75221 7.89048 6.63039 7.89048H3.46015C3.33753 7.89048 3.2284 7.96786 3.18713 8.08333L2.57721 9.80675C2.53634 9.92222 2.42682 9.9996 2.3042 9.9996H0.789516C0.588722 9.9996 0.44904 9.8 0.51769 9.61111V9.61151ZM4.38991 5.86468H5.68872C5.88872 5.86468 6.0284 5.66667 5.96134 5.47817L5.31571 3.66429C5.22444 3.40833 4.86293 3.40754 4.77086 3.66349L4.11769 5.47738C4.04983 5.66587 4.18952 5.86468 4.38991 5.86468Z",
    fill: "#07D8AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleTextColorIcon);
export default __webpack_public_path__ + "static/media/StyleTextColorIcon.71c49e511f0de72ec811110fea47f2d4.svg";
export { ForwardRef as ReactComponent };